import React, { Component } from "react";
import { message, notification } from 'antd';
import autoBind from 'react-autobind';
import Utils from "./Utils";
import LogRocket from "logrocket";
//
class AlertController extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }
  //Actions
  getAPIError(resp, resp2) {
    console.error(resp, resp2)
    const errMessage = Utils.extractAPIErrors(resp, resp2);
    return errMessage;
  }
  showAPIErrorAlert(title, resp, resp2) {
    console.error(resp, resp2)
    let errMessage = Utils.extractAPIErrors(resp, resp2);
    //
    if (!errMessage) errMessage = "Unknown error.\nTry reloading the page, if the error persists, please, contact the support!";
    notification.error({ message: (!title ? 'Error' : title), description: errMessage });
    //Log rocket
    LogRocket.captureMessage(`[${title || 'Error'}] ${errMessage}`, {
      tags: { type: 'API Error Message' },
      extra: { title, description: errMessage, error1: JSON.stringify(resp), ...(resp2 ? { error2: JSON.stringify(resp2) } : {}) }
    });
  }
  showErrorAlert(title, description) {
    notification.error({ message: title, description: description });
    //Log rocket
    LogRocket.captureMessage(`[${title}] ${description}`, {
      tags: { type: 'Error Message' },
      extra: { title, description }
    });
  }
  showWarningAlert(title, description) {
    notification.warning({ message: title, description: description });
  }
  showSuccessAlert(title, description) {
    message.success(title + " " + description, 5);
  }
  showQuestionAlert(title, description) {
    return (window.confirm(title + "\n" + description));
  }
  showPromptAlert(title, description) {
    return (window.prompt(title + "\n" + description));
  }
  //UI
  render() {
    return (<></>);
  }
}
export default AlertController;
